import HeaderV2 from "./v2/header";
import FooterV2 from "./v2/footer";
import Link from "next/link";
import "./v2/styles/_error-page.module.scss";

export default function ErrorPage404({  }) {
    return(
        <>
            <div className={'global-wrapper'} >
                <HeaderV2 />
                <section className={'error-page button-absolute'}>
                    <div className={'container'}>
                        <div className={'error-heading'}>
                            <h1>Sorry About That</h1>
                            <p>It looks like you're trying to access a page that either has been deleted or never even existed.</p>
                            <div className={"d-flex"}>
                                <Link href={"/"} className={"ahref-btn primary"}> Go to Home</Link>
                                <Link href={"/contact-us/"} className={"ahref-btn secondary"}> Contact Us</Link>
                            </div>
                        </div>
                    </div>
                    <div className={'error-image'}>
                        <div className={'container'}>
                            <img src={'/images/404.png'} alt={'404-page'} />
                        </div>
                    </div>
                </section>
                <FooterV2 />
            </div>
        </>

    )
}